import {Component, Inject, OnInit} from '@angular/core';
import {AwsUtil} from "./service-auth/aws.service";
import {CognitoUtil, LoggedInCallback} from "./service-auth/cognito.service";
import {StartupService} from "./service-ui/startup.service";
import {NotificationsService} from "./service-data/notifications.service";
import {WindowRef} from "./WindowRef";
import { LOCALE_ID } from '@angular/core';
import {Router} from "@angular/router";
import {LanguagePipe} from "./pipe/language.pipe";
import {MeasurementUnits} from "./service-ui/measurement-units";
import {SubscriptionService} from "./service-data/subscription.service";
import {BookService} from "./service-data/book.service";
import {DomSanitizer, Title} from "@angular/platform-browser";
import {AndTableFilter} from "./table/AndTableFilter";
import {OrTableFilter} from "./table/OrTableFilter";
import {NumericRangeTableFilter} from "./table/NumericRangeTableFilter";
import {TableFilter} from "./table/TableFilter";
import {StringRangeTableFilter} from "./table/StringRangeTableFilter";
import {NumericTableFilter} from "./table/NumericTableFilter";
import {DateTableFilter} from "./table/DateTableFilter";
import {DateRangeTableFilter} from "./table/DateRangeTableFilter";
import {NotTableFilter} from "./table/NotTableFilter";
import {DataEnumTableFilter} from "./table/DataEnumTableFilter";
import {CompositeStringTableFilter} from "./table/CompositeStringTableFilter";
import {PackageService} from "./service-data/package.service";
import {PrintNodeOrderService} from "./service-data/print-node-order.service";
import {PrintNodeOrderItemService} from "./service-data/print-node-order-item.service";
import {OrderItemService} from "./service-data/order-item.service";
import {ManufacturingSetService} from "./service-data/manufacturing-set.service";
import {ManufacturingTaskService} from "./service-data/manufacturing-task.service";
import {IssueService} from "./service-data/issue.service";
import {FacilityInventoryProductService} from "./service-data/facility-inventory-product.service";
import {ProductService} from "./service-data/product.service";
import {OrderItemToPackageService} from "./service-data/order-item-to-package.service";
import {BodyService} from "./service-data/body.service";
import {CoverService} from "./service-data/cover.service";
import {ResourceService} from "./service-data/resource.service";
import {FacilityInvoiceService} from "./service-data/facility-invoice.service";
import {PackageTypeService} from "./service-data/package-type.service";
import {OrganizationService} from "./service-data/organization.service";
import {ManufacturingTaskBucketPeriodService} from "./service-data/manufacturing-task-bucket-period.service";
import {ManufacturingTaskBucketService} from "./service-data/manufacturing-task-bucket.service";
import {ManufacturingResourceService} from "./service-data/manufacturing-resource.service";
import {StringTableFilter} from "./table/StringTableFilter";
import {DraftService} from "./service-data/draft.service";
import {PackageAndShippingComputationService} from "./service-data/package-and-shipping-computation.service";
import {NumberFormattingPipe} from "./pipe/number-formatting.pipe";
import {MatIconRegistry} from "@angular/material/icon";
import {DraftCoverService} from "./service-data/draft-cover.service";
import {DraftBodyService} from "./service-data/draft-body.service";
import {DialogLabelUpgraderService} from "./service-ui/dialog-label-upgrader.service";
import {EcommerceConnectionService, ShopifyInstallFinalizeRequest} from "./service-data/ecommerce-connection.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, LoggedInCallback {
  // We need these classes to be loaded so we can load them by name later
  // const tableFilter = new TableFilter(undefined);
    // .classMap['StringTableFilter'] = StringTableFilter;
  // public stringTableFilter: StringTableFilter;
  // public andTableFilter: AndTableFilter;
  // public orTableFilter: OrTableFilter;
  // public numericRangeTableFilter: NumericRangeTableFilter;

  constructor(public startupService: StartupService,
              public router: Router,
              public notificationsService: NotificationsService,
              private matIconRegistry: MatIconRegistry,
              private packageAndShippingComputationService: PackageAndShippingComputationService,
              private packageService: PackageService,
              private printNodeOrderService: PrintNodeOrderService,
              private printNodeOrderItemService: PrintNodeOrderItemService,
              private orderItemService: OrderItemService,
              private manufacturingSetService: ManufacturingSetService,
              private manufacturingTaskService: ManufacturingTaskService,
              private manufacturingTaskBucketService: ManufacturingTaskBucketService,
              private manufacturingTaskBucketPeriodService: ManufacturingTaskBucketPeriodService,
              private manufacturingResourceService: ManufacturingResourceService,
              private issueService: IssueService,
              private facilityInventoryProductService: FacilityInventoryProductService,
              private productService: ProductService,
              private orderItemToPackageService: OrderItemToPackageService,
              private bodyService: BodyService,
              private coverService: CoverService,
              private resourceService: ResourceService,
              private bookService: BookService,
              private organizationService: OrganizationService,
              private facilityInvoiceService: FacilityInvoiceService,
              private packageTypeService: PackageTypeService,
              private draftService: DraftService,
              private draftCoverService: DraftCoverService,
              private draftBodyService: DraftBodyService,
              public cognitoUtil: CognitoUtil,
              public awsUtil: AwsUtil,
              public winRef: WindowRef,
              @Inject(LOCALE_ID) locale: string,
              public subscriptionService: SubscriptionService,
              public titleService: Title,
              public sanitizer: DomSanitizer,
              private dialogLabelUpgrader: DialogLabelUpgraderService,
              private ecommerceConnectionService: EcommerceConnectionService ) {
    this.dialogLabelUpgrader.install();
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    TableFilter.classMap['String'] = new StringTableFilter({ type: 'String', fieldName: 'title', value: 'title' });
    TableFilter.classMap['String'] = TableFilter.classMap['String'].constructor;
    TableFilter.classMap['CompositeString'] = new CompositeStringTableFilter({ type: 'CompositeString', fieldName: 'title', value: 'title' });
    TableFilter.classMap['CompositeString'] = TableFilter.classMap['CompositeString'].constructor;
    TableFilter.classMap['StringRange'] = new StringRangeTableFilter({ type: 'StringRange', fieldName: 'title', startValue: 'title1', endValue: 'title2' });
    TableFilter.classMap['StringRange'] = TableFilter.classMap['StringRange'].constructor;
    TableFilter.classMap['Date'] = new DateTableFilter({ type: 'Date', fieldName: 'dueDate', value: '2020/01/01' });
    TableFilter.classMap['Date'] = TableFilter.classMap['Date'].constructor;
    TableFilter.classMap['DateRange'] = new DateRangeTableFilter({ type: 'DateRange', fieldName: 'dueDate', startValue: '2019/01/01', endValue: '2020/01/01' });
    TableFilter.classMap['DateRange'] = TableFilter.classMap['DateRange'].constructor;
    TableFilter.classMap['Not'] = new NotTableFilter({ type: 'Not', child: { type: 'String', fieldName: 'title', value: 'title' }});
    TableFilter.classMap['Not'] = TableFilter.classMap['Not'].constructor;
    TableFilter.classMap['Numeric'] = new NumericTableFilter({ type: 'Numeric', fieldName: 'quantity', value: 1});
    TableFilter.classMap['Numeric'] = TableFilter.classMap['Numeric'].constructor;
    TableFilter.classMap['NumericRange'] = new NumericRangeTableFilter({ type: 'NumericRange', fieldName: 'quantity', startValue: 1, endValue: 100 });
    TableFilter.classMap['NumericRange'] = TableFilter.classMap['NumericRange'].constructor;
    TableFilter.classMap['Or'] = new OrTableFilter({ type: 'Or', children: [{ type: 'String', fieldName: 'title', value: 'title' }, { type: 'String', fieldName: 'title', value: 'title' }]});
    TableFilter.classMap['Or'] = TableFilter.classMap['Or'].constructor;
    TableFilter.classMap['And'] = new AndTableFilter({ type: 'And', children: [{ type: 'String', fieldName: 'title', value: 'title' }, { type: 'String', fieldName: 'title', value: 'title' }]});
    TableFilter.classMap['And'] = TableFilter.classMap['And'].constructor;
    TableFilter.classMap['DataEnum'] = new DataEnumTableFilter({ type: 'DataEnum', fieldName: 'carrier', value: '', values: ['UPS', 'USPS'] } );
    TableFilter.classMap['DataEnum'] = TableFilter.classMap['DataEnum'].constructor;

    TableFilter.create({ type: 'NumericRange', fieldName: 'quantity', startValue: 1, endValue: 100 });
    localStorage.setItem('localeId', locale);
    console.log('locale set to:' + locale);
    console.log("AppComponent: constructor");
    const x = new NumericRangeTableFilter({ type: 'NumericRange', fieldName: 'quantity', startValue: 1, endValue: 100 });
  }

  ngOnInit() {
    console.log("AppComponent: Checking if the user is already authenticated");
    // Capture any inbound external-callback parameters (e.g. Shopify
    // app install) BEFORE any data load runs, so a short-lived OAuth
    // code is not lost across a Cognito redirect. See
    // docs/architecture/routing.md "External callback entry points".
    this.captureExternalCallbackParams();
    this.startupService.isAuthenticated(this); // not sure if this should be here or not
    const startupS = this.startupService;
    const languageStringElements = document.getElementsByClassName('languageStringText');
    startupS.dir = 'ltr';
    const _this = this;
    Array.prototype.filter.call(languageStringElements, function(languageStringElement) {
      const languageKey = languageStringElement.id.substring('languageStringText'.length);
      const languageValue = languageStringElement.innerText;
      LanguagePipe.add(languageKey, languageValue);
      if ( languageKey === 'dir') {
        startupS.dir = languageValue;
      }
      if ( languageKey === 'lang') {
        NumberFormattingPipe.setDefaultLanguage(languageValue);
        startupS.lang = languageValue;
      }
      if ( languageKey === 'floatStart') {
        console.log('floatStart:' + languageValue);
      }
      if ( languageKey === 'floatEnd') {
        console.log('floatEnd:' + languageValue);
      }
      if ( languageKey === 'Main Organization Name') {
        _this.titleService.setTitle( languageValue );
      }
      // if ( languageKey === 'limitToOnlyCSVAndOrderHistory' && languageValue === 'limit') {
      //   startupS.limitToOnlyCSVAndOrderHistory = true;
      // }
      if ( languageKey === 'showLanguagesOptions' && languageValue === 'hide') {
        startupS.showLanguagesOptions = false;
      }
      // if ( languageKey === 'backgroundImage') {
      //   const bodyElements = document.getElementsByTagName("body");
      //   Array.prototype.filter.call(bodyElements, function(bodyElement) {
      //     // bodyElement.style.backgroundImage = _this.sanitizer.bypassSecurityTrustStyle(languageValue);
      //     // bodyElement.style.background = _this.sanitizer.bypassSecurityTrustStyle(languageValue);
      //     bodyElement.class = languageValue;
      //     // bodyElement.style.background = '#ff0000';
      //   });
      // }
      // console.log("LanguageString: " + languageKey + " " + languageValue );
    });
    // The runtime translation map is only now populated. MeasurementUnits
    // caches its unit labels ("in"/"mm", "lbs"/"kg", "in³"/"cm³") the
    // first time it is asked for one, so anything that resolved a label
    // during bootstrap would have cached the raw id. Drop that cache.
    MeasurementUnits.refresh();
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    const notificationServiceLocal = this.notificationsService;
    if ( isLoggedIn ) {
      console.log("AppComponent isLoggedIn - " + isLoggedIn + " - " + message);
      console.log("AppComponent: the user is authenticated: " + isLoggedIn);
      const mythis = this;
      this.cognitoUtil.getIdToken({
        callback() {

        },
        callbackWithParam(token: any) {
          // Include the passed-in callback here as well so that it's executed downstream
          console.log("AppComponent: calling initAwsService in callback");
          mythis.awsUtil.initAwsService(null, isLoggedIn, token);
          // notificationServiceLocal.startNotification();
          // If an external callback (e.g. Shopify install) was
          // captured before auth, finalize it now that we have a
          // valid Cognito session and a selected role.
          mythis.finalizePendingShopifyInstall();
        }
      });
      // this.themeService.getCoverThemes().subscribe( coverThemes => {
      //   this.startupService.setCoverThemes(coverThemes);
      // });

    } else {
      console.log("AppComponent isLoggedIn - " + isLoggedIn + " - " + message);
      this.router.navigate(['/home/login']);  }
  }

  /**
   * Inspect the current browser URL for known external-callback
   * query parameters and stash them on the `StartupService` for
   * post-auth consumption. Today only Shopify install is handled,
   * in two flavors:
   *
   * 1. **Return from server-side callback (preferred).** The
   *    server's `GET /shopify` handler has already validated the
   *    Shopify HMAC, exchanged the `code`, and upserted the
   *    `EcommerceConnection`. It then redirects the browser back
   *    to the SPA `returnTo` URL with `shop`, optional `host`,
   *    `installed=1`, and `ecommerceConnectionId` query params.
   *    No further API call is needed — we simply queue a
   *    post-startup route pointing at the new connection.
   *
   * 2. **Legacy direct callback (fallback).** Shopify drops the
   *    user on the SPA carrying the raw OAuth callback params
   *    (`shop`, `code`, `hmac`, `timestamp`). We stash these on
   *    `StartupService.pendingShopifyParams` and, after auth,
   *    POST them to `/1.0/ui/ecommerceconnection/shopify/finalize`
   *    via `finalizePendingShopifyInstall()`. Server still
   *    supports this path for compatibility but the new install
   *    flow uses option (1).
   *
   * Idempotent: safe to call once on `AppComponent.ngOnInit()`. If
   * the URL doesn't carry either expected parameter set, nothing is
   * stashed.
   */
  private captureExternalCallbackParams(): void {
    if (typeof window === 'undefined' || !window.location || !window.location.search) {
      return;
    }
    let params: URLSearchParams;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      console.log('AppComponent.captureExternalCallbackParams: could not parse URL query string', e);
      return;
    }

    // Flavor 3 (CURRENT managed-install flow): the account-linking page.
    // Shopify's embedded shell opens `/shopify/link?nonce=...` in a new
    // top-level tab. Captured here rather than read in the component so it
    // survives the Cognito login detour, and so the credential can be taken
    // out of the address bar immediately.
    const nonce = params.get('nonce');
    const path = window.location.pathname || '';
    if (nonce && path.indexOf('shopify/link') !== -1) {
      this.startupService.pendingShopifyLinkNonce = nonce;
      // Come back here after sign-in / role selection. Re-armed by
      // ShopifyLinkComponent before each subsequent detour, because
      // StartupComponent clears it on consumption.
      this.startupService.pendingPostStartupRoute = ['/shopify/link'];
      // Take the nonce out of the URL: it is a bearer credential for a store
      // and otherwise sits in history, in a bookmark, and in the Referer
      // header of the next outbound request. Deliberately NOT logged.
      try {
        window.history.replaceState({}, '', path);
      } catch (e) {
        console.log('AppComponent: could not strip the Shopify link nonce from the URL', e);
      }
      console.log('AppComponent: captured a Shopify account-linking nonce');
      return;
    }

    // Flavor 1: server-callback return. Recognized by `installed=1`
    // plus a numeric `ecommerceConnectionId`. The shop param is
    // not strictly required but normally present.
    const installed = params.get('installed');
    const ecommerceConnectionIdParam = params.get('ecommerceConnectionId');
    if (installed === '1' && ecommerceConnectionIdParam) {
      const ecommerceConnectionId = Number(ecommerceConnectionIdParam);
      if (isFinite(ecommerceConnectionId) && ecommerceConnectionId > 0) {
        this.startupService.pendingPostStartupRoute = [
          '/secure/ecommerce',
          { ecommerceConnectionId: ecommerceConnectionId },
        ];
        console.log(`AppComponent: captured Shopify install return for ecommerceConnectionId=${ecommerceConnectionId}, shop=${params.get('shop') || '(none)'}`);
        return;
      }
    }

    // Flavor 2: legacy direct-callback fallback. Recognized by the
    // full Shopify callback param set. The `shop` value ending in
    // `.myshopify.com` is a low-cost sanity filter.
    const shop = params.get('shop');
    const code = params.get('code');
    const hmac = params.get('hmac');
    const timestamp = params.get('timestamp');
    if (shop && code && hmac && timestamp && shop.indexOf('.myshopify.com') !== -1) {
      this.startupService.captureShopifyInstallParams({
        shop: shop,
        code: code,
        hmac: hmac,
        timestamp: timestamp,
        state: params.get('state') || undefined,
        host: params.get('host') || undefined,
      });
      console.log(`AppComponent: captured legacy Shopify install params for shop=${shop}`);
    }
  }

  /**
   * If Shopify install parameters were captured pre-auth, exchange
   * them for an active EcommerceConnection now and arrange for
   * `StartupComponent` to land the user on the EcommerceConnection
   * settings page once data-load completes.
   *
   * Cleared after consumption regardless of outcome so a stale set
   * of params can't re-trigger on a subsequent role-change.
   *
   * 🛑 **DO NOT DELETE — hold requested by server 2026-10-14.**
   * Dead on the current install path, but the server has asked that
   * this fallback stay until `POST /shopify/session` (token
   * exchange) is deployed. See
   * `docs/architecture/shopify-authentication.md` §12.4 item 10.
   */
  private finalizePendingShopifyInstall(): void {
    const pending = this.startupService.pendingShopifyParams;
    if (!pending) {
      return;
    }
    // Consume now; do not leave the payload sitting on the service.
    this.startupService.pendingShopifyParams = null;

    const req: ShopifyInstallFinalizeRequest = {
      shop: pending.shop,
      code: pending.code,
      hmac: pending.hmac,
      timestamp: pending.timestamp,
      state: pending.state,
      host: pending.host,
    };
    console.log(`AppComponent: finalizing Shopify install for shop=${req.shop}`);
    this.ecommerceConnectionService.shopifyInstallFinalize(req).subscribe(
      response => {
        if (response && response.ecommerceConnectionId) {
          console.log(`AppComponent: Shopify finalize succeeded — ecommerceConnectionId=${response.ecommerceConnectionId}, created=${response.created}, setupStatus=${response.setupStatus}, warnings=${(response.warnings || []).length}`);
          // Queue the post-startup destination. StartupComponent
          // consumes this once its data pipeline completes; matrix
          // entries are passed straight through Router.navigate.
          this.startupService.pendingPostStartupRoute = [
            '/secure/ecommerce',
            { ecommerceConnectionId: response.ecommerceConnectionId },
          ];
        } else {
          console.log('AppComponent: Shopify finalize returned no ecommerceConnectionId');
        }
      },
      error => {
        console.error('AppComponent: Shopify finalize failed', error);
      }
    );
  }
}

